<template>
  <div>
    <b-form-group>
      <template v-slot:label>
        <label>{{$t('files.base.workgroup')}}</label><br />
        <b-form-checkbox
            v-model="checkAll"
            :indeterminate="indeterminate"
            aria-describedby="workgroups"
            aria-controls="workgroups"
            @change="handleChangeCheckAll">
          {{ checkAll ? $t('files.base.selectUnSelectAll') : $t('files.base.selectAll') }}
        </b-form-checkbox>
      </template>
      <b-form-checkbox-group
          id="flavors"
          v-model="selected"
          :options="workgroups"
          name="workgroups"
          class="ml-4"
          aria-label="Individual workgroups"
          stacked
      ></b-form-checkbox-group>
    </b-form-group>
  </div>
</template>

<script>
  import {mapActions} from "vuex";

  export default {
    name: 'slicing-profile-rights-form',
    props: ['profile'],
    data() {
      return {
        selected: [],
        indeterminate: true,
        checkAll: false
      }
    },
    created() {
      this.updateSelected(this.profile);
    },
    computed: {
      workgroups() {
        let list = [];
        for(let i in this.profile.workgroup_rights) {
          list.push({text: this.profile.workgroup_rights[i].name, value: i});
        }
        return list;
      }
    },
    methods: {
      ...mapActions(['updateProfileWorkgroupRights']),

      handleChangeCheckAll(checked) {
        this.selected = checked ? this.workgroups.map(option => option.value) : [];
      },

      updateSelected(profile) {
        let selected = [];
        for (let i in profile.workgroup_rights) {
          if (profile.workgroup_rights[i].enabled) {
            selected.push(i);
          }
        }

        this.selected = selected;
        this.indeterminate = selected.length > 0;
        this.checkAll = selected.length === profile.workgroup_rights.length;
      },

      handleUpdateWorkgroupRights() {
        let workgroups = {};
        for (let id in this.profile.workgroup_rights) {
          let enabled = false;
          for (let i in this.selected) {
            if (this.selected[i] == this.profile.workgroup_rights[id].name) {
              enabled = true;
              break;
            }
          }
          workgroups[id] = enabled;
        }
        this.updateProfileWorkgroupRights({profileId: this.profile.id, workgroups: workgroups}).then(({data}) => {
          if (!data.result) {
            this.msgBoxOk(data.message, {title: 'Update profile rights error'});
          }
        });
      }
    },
    watch: {
      profile: function(newProfile) {
        this.updateSelected(newProfile);
      },
      selected: function(newVal) {
        if (newVal.length === 0) {
          this.indeterminate = false;
          this.checkAll = false;
        } else if (newVal.length === this.workgroups.length) {
          this.indeterminate = false;
          this.checkAll = true;
        } else {
          this.indeterminate = true;
          this.checkAll = false;
        }
      }
    }
  }
</script>
